export default __webpack_public_path__ + "static/media/icon-theft.f8b5ff5d.svg";